import { AnalyticsEventTopic, getOafIdFromEvent, SEARCH_RESULT_CLICK_ACTION, typeMapping } from '../analyticsHelper';
import { AnalyticsWeightings } from '../analyticsWeightings';
import { CoveoAnalyticsCustomData, CoveoAnalyticsEvent, CoveoEventType } from './coveoEventType';

interface ClickCoveoAnalyticsCustomData extends CoveoAnalyticsCustomData {
    contentIdValue: string;
    contentIdKey: string;
    listingCategoryName: string;
}

interface CoveoClickEvent extends CoveoAnalyticsEvent {
    visitor: string;
    queryPipeline: string;
    documentTitle: string;
    rankingModifier: string;
    actionCause: string;
    searchQueryUid: string;
    documentPosition: number;
    sourceName: string;
    collectionName: string;
    documentUriHash: string;
    documentUrl: string;
    documentUri: string;
    originLevel2?: string;
    customData: ClickCoveoAnalyticsCustomData;
}

export class ClickCoveoEventType extends CoveoEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            event.searchContext?.eventAction === SEARCH_RESULT_CLICK_ACTION
        );
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): CoveoClickEvent {
        const coveoAttributes = event.searchContext;
        const baseEvent = this.baseBody(event);
        const listingCategories = this.getListingCategories(event.listing.listingCategories);
        const { originLevel1, originLevel2 } = coveoAttributes;
        const originLevels = Object.assign({}, originLevel1 && { originLevel1 }, originLevel2 && { originLevel2 });
        return {
            ...baseEvent,
            outcome: AnalyticsWeightings.clickPoints,
            visitor: event.token,
            queryPipeline: coveoAttributes.queryPipeline,
            searchQueryUid: coveoAttributes.searchQueryUid,
            documentTitle: event.listing.title,
            rankingModifier: coveoAttributes.rankingModifier,
            actionCause: coveoAttributes.actionCause || this.actionCause(coveoAttributes.type),
            documentPosition: coveoAttributes.documentPosition,
            sourceName: coveoAttributes.sourceName,
            collectionName: coveoAttributes.collection,
            documentUriHash: coveoAttributes.documentUriHash,
            documentUrl: coveoAttributes.documentUrl,
            documentUri: coveoAttributes.documentUri,
            ...originLevels,
            customData: {
                ...baseEvent.customData,
                contentIdValue: getOafIdFromEvent(event),
                contentIdKey: 'permanentId',
                listingCategoryName: (listingCategories?.length && listingCategories[0]) || '',
            },
        };
    }

    actionCause(type?: string): string {
        if (!type) {
            return 'documentOpen';
        }
        return `${typeMapping(type)}RcmdClick`;
    }

    getPath(): string {
        return 'click';
    }

    // @ts-expect-error * Automated Type Error Fix
    getListingCategories(categories) {
        if (!categories) {
            return [];
        }
        // @ts-expect-error * Automated Type Error Fix
        return categories.reduce((flatten, category) => {
            if (category.name) {
                flatten.push(category.name);
            }
            return flatten;
        }, []);
    }
}
